module.exports = "<footer class=\"frg-footer\">\n  <div class=\"area\">\n    <ul class=\"brand\">\n      <li><a href=\"#\"><img src=\"/assets/images/freeground-icon.svg\" alt=\"Freeground Icon\"></a></li>\n      <li><p>Copyright &copy; Freeground LLC. All Rights Reserved.</p></li>\n    </ul>\n  </div>\n</footer>\n"


//////////////////
// WEBPACK FOOTER
// /Users/jessepinuelas/Development/jesse/freeground.io/src/app/footer/footer.component.html
// module id = ../../../../../src/app/footer/footer.component.html
// module chunks = main